<template>
  <div class="custom-autocomplete">
    <v-subheader
      class="pa-0"
      v-if="label"
    >
      <label
        for="selection"
        class="neutral-cold-051--text text-body-3"
      >{{ label }}</label>
    </v-subheader>
    <v-autocomplete
      v-bind="{ ...$attrs, ...commonAttrs }"
      v-on="$listeners"
      item-color="primary-001"
      multiple
      chips
      outlined
      deletable-chips
      clear-icon="mdi-close-circle"
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.selected"
          @click:close="data.parent.selectItem(data.item)"
        >
          <p class="mb-0 chip-text">
            {{ data.item[$attrs['item-text']] }}
          </p>
        </v-chip>
      </template>
      <template v-slot:item="{ attrs, item, select, selected }">
        <v-list-item-title
          class="text-body-2 neutral-041--text"
        >
          {{ item[$attrs['item-text']] }}
        </v-list-item-title>
      </template>
      <template
        v-for="(_, scopedSlotName) in $scopedSlots"
        #[scopedSlotName]="slotData"
      >
        <slot
          :name="scopedSlotName"
          v-bind="slotData"
        />
      </template>
      <template
        v-for="(_, slotName) in $slots"
        #[slotName]
      >
        <slot :name="slotName" />
      </template>
      <template slot="append-outer">
        <v-icon size="16">
          $vuetify.icons.inputErrorIcon
        </v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'MultiAutoComplete',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    commonAttrs() {
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.custom-autocomplete {
  .v-select__slot {
    input {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: $neutral-040;
      &::placeholder {
        color: $neutral-cold-051;
      }
    }
  }
  .v-select.v-select--chips .v-select__selections {
    min-height: 32px;
  }
  .v-select .v-chip {
    z-index: 1;
  }

  .v-autocomplete {
    &.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
      min-height: 32px;
    }
    &.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
      padding: 0 12px 0 12px;
      min-height: 32px;
    }

    // Default Style
    fieldset {
      background: $neutral-cold-056;
      border: none;
      transition: all 0.3s ease-in-out;
    }

    // Hover Style
    &:hover fieldset{
      background: $neutral-cold-054;
    }

    // Focus Style
    &.v-select--is-menu-active fieldset{
      background: $neutral-047;
      border: 1px solid $primary-001;
      box-shadow: 0px 0px 0px 2px rgba(64, 143, 255, 0.25);
    }

    // Disabled Style
    &.v-input--is-disabled {
      fieldset {
        background: $neutral-cold-056;
      }
      & .v-select__slot input {
        color: $neutral-043;
      }
    }

    // Error Style
    &.error--text {
      fieldset {
        background: $neutral-047;
      }
      &.v-input--is-focused {
        fieldset {
          box-shadow: 0px 0px 0px 2px rgba($danger-021, 25%)
        }
      }
    }
    & .v-messages{
      margin-top: 2px;
      margin-left: 22px;
    }
    & .v-input__append-outer {
      position: absolute;
      bottom: -3px;
      left: 0;
      margin-left: 0;
      display: none;
    }
    &.error--text .v-input__append-outer {
      display: inline-flex;
    }

    // Arrow icon Style
    &.v-select--is-menu-active, &.v-input--is-focused {
      & .v-input__icon--append .v-icon {
        color: $neutral-042 !important;
        caret-color: $neutral-042 !important;
      }
    }

    // Clearable Icon Style
    .v-input__append-inner .v-input__icon--clear {
      display: none;
      .v-icon {
        font-size: 16px;
        color: $neutral-041 !important;
        caret-color: $neutral-041 !important;
      }
    }
    &.v-select--is-menu-active, &:hover  {
      .v-input__append-inner .v-input__icon--clear {
        display: flex;
      }
    }

    &.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-input--dense .v-select__selections {
      min-height: 32px;
      padding: 0;
    }
    &.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
      margin-top: 0;
      align-self: center;
    }

    &.v-select--is-multi.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
      min-height: 32px;
      padding: 0;
    }
    &:not(.v-input--is-disabled).v-select.v-text-field input {
      min-height: 32px;
    }
    &.v-select--is-multi .v-input__append-inner {
      margin-top: 4px;
    }
  }
}

.chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
